(function () {

  // Inject styles once
  if (!document.getElementById('variant-alert-styles')) {
    const style = document.createElement('style');
    style.id = 'variant-alert-styles';
    style.textContent = `
      variant-alert {
        display: block;
        width: 100%;
      }
      variant-alert:empty {
        display: none;
      }

      /* Main product page alert */
      .variant-alert__inner {
        font-size: 12px;
        line-height: 1.5;
        padding: 8px 0 0 0;
        margin-top: 8px;
        border-top: 1px solid #e0e0e0;
      }
      .variant-alert__inner p {
        margin: 0;
      }

      floated-form .variant-alert__inner p {
        display: inline;
        margin: 0;
      }
      .variant-alert__inner strong {
        font-weight: 600;
        letter-spacing: 0.05em;
      }

      label.notify_me {
        text-transform: capitalize;
      }

      /* Sticky bar — force full width row below size buttons */
      floated-form .product__info-main_content {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
      }
      floated-form variant-alert {
        flex: 0 0 100%;
        width: 100%;
        order: 99;
        overflow: hidden;
      }
      floated-form variant-alert .variant-alert__inner {
        font-size: 12px;
        line-height: 1.5;
        padding: 8px 0 0 0;
        margin-top: 8px;
        border-top: 1px solid #e0e0e0;
        white-space: normal;
        word-wrap: break-word;
        overflow-wrap: break-word;
      }
      floated-form variant-alert .variant-alert__inner p {
        display: block;
        margin: 0;
        white-space: normal;
        word-wrap: break-word;
        overflow-wrap: break-word;
      }
      floated-form variant-alert .variant-alert__inner strong {
        display: inline;
        font-weight: 600;
        margin-right: 4px;
        letter-spacing: 0.05em;
      }
    `;
    document.head.appendChild(style);
  }

  // Sync price from main product page to sticky bar on variant change
  /*
  document.addEventListener('variant:change', function(event) {
    const { sectionId } = event.detail;
    setTimeout(function() {
      const mainSectionId = sectionId.replace(/^floated-/, '');
      const mainPrice = document.getElementById('price-' + mainSectionId);
      const floatedPrice = document.querySelector('.product__popup_main .text .price');
      if (mainPrice && floatedPrice) {
        floatedPrice.innerHTML = mainPrice.innerHTML;
      }
    }, 500);
  });
*/
  function getBlockSettings(sectionId) {
    const el = document.getElementById('variant-alert-' + sectionId);
    if (!el) return null;
    return {
      mtoMsg: el.getAttribute('data-mto-msg'),
      backstockMsg: el.getAttribute('data-backstock-msg'),
      lowStockMsg: el.getAttribute('data-low-stock-msg'),
      stockThreshold: parseInt(el.getAttribute('data-stock-threshold') || '3', 10),
    };
  }

  function getVariantAvailabilityData(sectionId) {
    const el = document.getElementById('variant-availability-data-' + sectionId);
    if (!el) return [];
    return JSON.parse(el.textContent);
  }

  class VariantAlert extends HTMLElement {
    connectedCallback() {
      this._sectionId = this.getAttribute('data-section-id');
      this._productUrl = this.getAttribute('data-product-url');
      this._handleVariantChange = this._onVariantChange.bind(this);
      document.addEventListener('variant:change', this._handleVariantChange);
    }

    disconnectedCallback() {
      document.removeEventListener('variant:change', this._handleVariantChange);
    }

    _onVariantChange(event) {
      const { sectionId, variant } = event.detail;
      const normalize = (id) => id ? id.replace(/^floated-/, '') : id;
      if (normalize(sectionId) !== normalize(this._sectionId)) return;
      if (!variant) { this._clear(); return; }
      this._updateFromData(variant);
    }

    _updateFromData(variant) {
      const settings = getBlockSettings(this._sectionId);
      if (!settings) return;

      const allVariants = getVariantAvailabilityData(this._sectionId);
      const variantData = allVariants.find(v => v.id === variant.id);
      if (!variantData) return;

      const totalInventory = allVariants.reduce(
        (sum, v) => sum + (v.inventory_quantity || 0), 0
      );

      const availability = variantData.availability || '';
      const isMTO = [
        'made to order',
        'auf bestellung gefertigt',
      ].includes(availability.toLowerCase().trim());

      let text = null;

      if (!variantData.available) {
        text = null;
      } else if (isMTO) {
        text = totalInventory <= 0 ? settings.mtoMsg : settings.backstockMsg;
      } else if (
        variantData.inventory_quantity <= settings.stockThreshold &&
        variantData.inventory_quantity > 0
      ) {
        text = settings.lowStockMsg.replace('[[amount]]', variantData.inventory_quantity);
      } else if (
        variantData.inventory_quantity <= 0 &&
        variantData.inventory_management &&
        variantData.inventory_policy === 'continue'
      ) {
        text = settings.backstockMsg;
      }

      this.innerHTML = text
        ? `<div class="variant-alert__inner">${text}</div>`
        : '';
    }

    _clear() {
      this.innerHTML = '';
    }
  }

  if (!customElements.get('variant-alert')) {
    customElements.define('variant-alert', VariantAlert);
  }
})();